import _ from 'underscore';
import Promise from 'bluebird';

/**
 * Get the user preference. Sever side will try to load from cache if any.
 * @param {object} jsDataCcRest jsData object
 * @param {String|Number} userId current user Id.
 * @returns {Promise<Object>} An object of user preference data.
 */
const BIDateRangeFilterKey = 18190;

export const getUserPreference = (jsDataCcRest, { userId, logging }) => {
  if (userId) {
    return jsDataCcRest.UserPreference.findAll({ uid: userId })
      .then((data) => {
        if (data && data.length) {
          try {
            const biDateRangeFilter = _.find(data, userPreference => userPreference.upkey === BIDateRangeFilterKey);
            /* istanbul ignore else */
            if (biDateRangeFilter && biDateRangeFilter.resultAsJsonString) {
              const preferenceJson = JSON.parse(decodeURIComponent(biDateRangeFilter.resultAsJsonString));
              /* istanbul ignore else */
              if (preferenceJson.BIDateRangeFilter) {
                return JSON.parse(preferenceJson.BIDateRangeFilter);
              }
            }
          } catch (e) {
            // ignore else branch coverage because it should be rarely hit
            /* istanbul ignore else */
            if (e instanceof SyntaxError) {
              if (logging && logging.trace) {
                logging.trace('getUserPreference', `resultAsJsonString JSON parse failed: ${e}`);
              }
            } else {
              throw e;
            }
          }
        }
        return undefined;
      });
  }

  return Promise.resolve({});
};
